import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { find } from "lodash";

import ApplicationMenu from "~/containers/Menus_v2/components/ApplicationMenu";
import WidgetContainer from "~/components/WidgetContainer";
import Invoice from "./components/Invoice";
import RevisaoDespesas from "./components/RevisaoDespesas";
import InvoiceUpdate from "./components/Invoice/InvoiceUpdate";
import MFiles from "./components/MFiles";
import CitizenCard from "./components/CitizenCard";
import CitizenCardUpdate from "./components/CitizenCard/CitizenCardUpdate";
import Tasks from "~/components/Tasks";
import ProtectedPage from "~/components/security/ProtectedPage";
import ProcessosFormHandler from "~/components/ProcessosFormHandler";

import { BPM_MIDDLEWARE, DATA_CAPTURE_APP } from "~/utils/constants";
import ContentContainer from "~/containers/ContentContainer";

import {
  getMenusByApplication,
  addItemsToMenu,
} from "~/store/ducks/applicationMenu/actionTypes";

const DataCapture = (props) => {
  const { isMongoOn } = props;
  let { path } = useRouteMatch();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.globalReducer);
  const { rawMenus, menu } = useSelector(
    (state) => state.applicationMenuReducer
  );

  useEffect(() => {
    if (user.legacyUsers) {
      let userBPM = user.legacyUsers.find(
        (item) => item.legacyApplication.label === BPM_MIDDLEWARE.context
      );
      let username = userBPM ? userBPM.username : null;
      dispatch(getMenusByApplication(username, "datacapture"));
    }
  }, [user, dispatch]);

  useEffect(() => {
    const processosMenu = find(menu, { name: "menu.datacapture.processos" });
    let items = [];
    let submenus;
    if (processosMenu) {
      const extraConfiguration_ = JSON.parse(
        processosMenu.extraConfiguration || false
      );
      submenus = extraConfiguration_.submenus
        ? extraConfiguration_.submenus
        : null;
      if (submenus) {
        Object.keys(submenus).forEach((key) => {
          //check if submenu has children
          let hasChildren = false;
          if (submenus[key].length == 0) hasChildren = false;
          else {
            submenus[key].every((flowid) => {
              const res = rawMenus.every((rm) => {
                //find flowid
                if (rm.url) {
                  let arr = rm.url.split("flowid=");
                  const flowid_ = arr[1];
                  if (flowid_ == flowid) {
                    console.log(flowid_, flowid, key);
                    hasChildren = true;
                    return false;
                  }
                  return true;
                }
                return true;
              });
              return res;
            });
          }
          if (hasChildren) {
            items.push({
              id: key,
              name: key,
              submenu: true,
              route: `${DATA_CAPTURE_APP}/processos/submenu/${key}`,
              menuParent: processosMenu ? processosMenu.id : null,
            });
          }
        });
      }
      const getProcessosMenuId = () =>
        processosMenu ? processosMenu.id : null;
      const getSubMenuParentId = (url) => {
        if (url) {
          let arr = url.split("flowid=");
          const flowId = arr[1];
          let id = getProcessosMenuId();
          Object.keys(submenus).forEach((key) => {
            if (submenus[key].some((i) => i == flowId)) {
              id = key;
            }
          });
          return id;
        } else return getProcessosMenuId();
      };
      rawMenus.forEach((item) => {
        items.push({
          name: item.label,
          url: item.url,
          route: `${DATA_CAPTURE_APP}/processos/form/${item.label}`,
          menuParent: submenus
            ? getSubMenuParentId(item.url)
            : getProcessosMenuId(),
        });
      });
      dispatch(addItemsToMenu(items));
    }
  }, [rawMenus, menu, dispatch]);

  return (
    <>
      <ApplicationMenu applicationName={DATA_CAPTURE_APP} />
      <Switch>
        <Route path={`${path}/tarefas`} exact>
          <ProtectedPage
            roles={["ADMIN", "DataCaptureUser", "DATACAPTUREUser"]}
          >
            <ContentContainer>
              <Tasks app={"datacapture"} className="main-card-v2" />
            </ContentContainer>
          </ProtectedPage>
        </Route>
        <Route exact path={`${path}/processos`}>
          <ProtectedPage
            roles={["ADMIN", "DataCaptureUser", "DATACAPTUREUser"]}
          >
            <div></div>
          </ProtectedPage>
        </Route>
        <Route path={`${path}/processos/submenu`}>
          <ProtectedPage
            roles={["ADMIN", "DataCaptureUser", "DATACAPTUREUser"]}
          >
            <div></div>
          </ProtectedPage>
        </Route>
        <Route path={`${path}/processos/form`}>
          <ProtectedPage
            roles={["ADMIN", "DataCaptureUser", "DATACAPTUREUser"]}
          >
            <ProcessosFormHandler
              app={"datacapture"}
              className="main-card-v2"
            />
          </ProtectedPage>
        </Route>

        <Route path={`${path}/revisaodespesas`} exact>
          <ProtectedPage
            roles={["ADMIN", "DataCaptureGestaoDespesasRequerente"]}
          >
            <ContentContainer>
              <RevisaoDespesas />
            </ContentContainer>
          </ProtectedPage>
        </Route>
        <Route path={`${path}/submissaodespesas`} exact>
          <ProtectedPage
            roles={[
              "ADMIN",
              "DataCaptureGestaoDespesasRequerente",
              "DataCaptureSubmissaoDespesas",
            ]}
          >
            <ContentContainer>
              <Invoice />
            </ContentContainer>
          </ProtectedPage>
        </Route>
        <Route path={`${path}/submissaodespesas/update/:batchId`} exact>
          <ProtectedPage
            roles={[
              "ADMIN",
              "DataCaptureGestaoDespesasRequerente",
              "DataCaptureSubmissaoDespesas",
            ]}
          >
            <InvoiceUpdate />
          </ProtectedPage>
        </Route>

        <Route path={`${path}/onboarding`} exact>
          <ProtectedPage roles={["ADMIN"]}>
            <ContentContainer>
              <CitizenCard />
            </ContentContainer>
          </ProtectedPage>
        </Route>
        <Route path={`${path}/onboarding/update/:batchId`} exact>
          <ProtectedPage roles={["ADMIN"]}>
            <CitizenCardUpdate />
          </ProtectedPage>
        </Route>

        <Route path={`${path}/documentSearch`} exact>
          <ContentContainer>
            <MFiles />
          </ContentContainer>
        </Route>

        <Route path={path} exact>
          {isMongoOn && (
            <ProtectedPage
              roles={[
                "ADMIN",
                "DataCaptureUser",
                "DATACAPTUREUser",
                "DataCaptureGestaoDespesasRequerente",
                "DataCaptureSubmissaoDespesas",
              ]}
            >
              <ContentContainer>
                <WidgetContainer />
              </ContentContainer>
            </ProtectedPage>
          )}
        </Route>
      </Switch>
    </>
  );
};
export default DataCapture;
